






































































import api from '@/services/api';
import { Component, Vue } from 'vue-property-decorator';
import UserProfile from '@/classes/UserProfile';
import { phoneFormatter } from '@/services/inputTools';

@Component
export default class ProfileForm extends Vue {
    public form: any = {
    cellPhoneNumber: undefined,
    workPhoneNumber: undefined,
    workPhoneNumberExt: undefined,
    faxNumber: undefined
    };
    private disableSave: boolean = false;

  public created() {
    const user: UserProfile = this.$store.getters.getActiveProfile;
    const tempForm = this.form;
    this.form = {...tempForm, ...user};
    this.form.cellPhoneNumber = phoneFormatter(this.form.cellPhoneNumber, {});
    this.form.workPhoneNumber = phoneFormatter(this.form.workPhoneNumber, {});
    this.form.faxNumber = phoneFormatter(this.form.faxNumber, {});
  }

  get activeUser() {
      return this.$store.getters.getActiveProfile;
  }
  public sendForm() {
    const url: string = 'profile/update';
    this.disableSave = true;
    api().post(url, this.form)
      .then((response) => {
        alert(response.data);
      })
      .then(() => {
        this.$store.dispatch('initializeUserProfile', true)
        .then(() => {
            this.$router.push('/administration/user/search');
        });
      })
      .catch((e) => {
        alert('Something went wrong.');
        this.disableSave = false;
      });
  }
}
